import blogImg1 from '../../assets/images/InsuranceNewHomepage/blog1.png';
import blogImg2 from '../../assets/images/InsuranceNewHomepage/blog2.png';
import blogImg3 from '../../assets/images/InsuranceNewHomepage/blog3.png';

import bike from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/Bike.svg';
import Car from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/Car.svg';
import LoanProtection from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/Loan Protection.svg';
import LoanUltra from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/Loan ulra.svg';
import LoanLite from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/LoanWallet1.svg';
import LoanWallet from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/LoanWallet.svg';
import OTTLoanProtect from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/OTTLoan Protect.svg';
import Wellnesslite from '../../assets/images/InsuranceNewHomepage/insuranceInnerIcons/Wellness lite.svg';
import img1 from '../../assets/images/InsuranceNewHomepage/insurance Icons/Wallet.svg';
import img4 from '../../assets/images/InsuranceNewHomepage/insurance Icons/Travel.svg';
import img5 from '../../assets/images/InsuranceNewHomepage/insurance Icons/OTT.svg';
import bannerImg from '../../assets/images/InsuranceNewHomepage/homepage_banner.png';

const link1 = 'https://blog.stashfin.com/understanding-insurance-your-shield-for-lifes-uncertainties/';
const link2 = 'https://blog.stashfin.com/exploring-cyber-insurance-importance-and-coverage/';
const link3 = 'https://blog.stashfin.com/home-insurance-features-and-advantages/';

export const faqs = [
  {
    question: '1. What do you mean by Insurance?',
    answer:
      'Insurance is a contract which is presented as a policy to be used as a risk management tool to ensure financial protection at the time of crisis. Insurance helps an individual to ensure financial protection against losses that may arise during an unforeseen event. An insurance policy is a contract between an individual (policyholder) and an insurance company (Insurance provider), under which, the individual makes regular payments known as premiums to the insurance company which in return pays the sum assured in case an unforeseen event such as demise of the policyholder, accident, damage to the vehicles or other possessions.',
  },
  {
    question: '2. Why is insurance important?',
    answer:
      'Unfortunate events like accidents, illnesses, and natural disasters come without any warning and thus it is necessary for you to keep yourself and your loved ones shielded against such unforeseen happenings. One of the best and simplest ways of keeping yourself secured against these contingent events which may cause a financial loss is buying an insurance policy.',
  },
  {
    question: '3. How Does Insurance Work?',
    answer:
      'As mentioned earlier, insurance is a legal contract between the policyholder and the insurance provider. The insurance policy carries all the details about the aspects and conditions under which the insurance provider will pay out the insurance amount to the policyholder or their nominee in case an unforeseen event occurs. Insurance is a financial tool which helps in ensuring financial protection of yourself and your family. Generally the person who has purchased the policy also known as policyholder has to pay premiums for the coverage available under the insurance policy. Any person can seek insurance from an insurance company.',
  },
  {
    question: '4. What are the types of insurance available?',
    answer:
      'There are several types of insurance available in India. The three most common types of insurance bought in India are as mentioned below: <br></br> 1. <b>Motor Insurance:</b> Motor insurance policy is a type of insurance policy that provides financial assistance in the event of an accident or mishap involving your vehicle. Motor insurance can be purchased for three categories of vehicles which are personally owned four wheeler, personally owned two wheeler (bikes and scooters) and commercial vehicles. There are three types of motor insurance available in India which are Third party Liability Cover, Comprehensive Cover and Stand Alone Own-Damage cover. According to a person’s coverage requirement for their vehicle, they can choose a motor insurance that fulfills their requirements. Third party motor insurance policy is mandatory in India for all vehicles, as per the Motor Vehicles Act. <br></br>  2. <b>Health Insurance:</b> Health insurance policies provide financial assistance to the policyholder in case they need to be admitted to the hospital for any kind of treatment. Additionally, some health insurance plans also cover the cost of treatment which are undertaken at home before the hospitalization or after discharge. There are several health insurance plans available in India such as Individual Health Insurance, Family Floater Plans, Critical Illness Cover, Senior Citizen Health Insurance, Group Health Insurance, Maternity Health Insurance and Personal Accident Insurance. <br></br> 3. <b>Life Insurance:</b> Life insurance is an agreement between an individual and an insurance company under which the insurance company promises to provide a sum assured (death benefit) to the family of the life assured in the event of an unforeseen death of the life assured. In case of no death, a sum assured known as the maturity benefit is provided to the life assured at the time of maturity of the policy under selective life insurance plans. There are 6 types of life insurance policies available in India which are Term Life Insurance, Unit-Linked Insurance Plan (ULIPs), Child Protection Plan, Money Back Plans, Retirement Plans and Endowment Plans.',
  },
  {
    question: '5. How to make a claim in insurance? ',
    answer:
      'There are two ways in which you can make a claim: <br></br> <b>Cashless claims:</b>  Get in touch with your insurer and inform them about your claim. Depending on the type of insurance (motor/health), the insurer will guide you about the cashless claim settlement process. In case of motor insurance, the insurer shares the details of a nearby cashless workshop if available and you just have to pay your part of the liability to get your car/bike repaired. In case of health insurance, you can get in touch with your TPA (Third Party Administrator) help desk at the time of hospitalization for a cashless claim. <br></br> <b>Reimbursement claim:</b> In case of unavailability of a cashless facility, you need to make a reimbursement claim. In case of motor insurance, you need to pay the entire claim amount up front (after informing the insurer of the claim) and get it reimbursed from the insurer after the repair of your car/bike. In case of health insurance, you need to pay the entire bill amount to the hospital (after informing the insurer) and get it reimbursed from the insurer post discharge from hospital.',
  },
];

export const blogs = [
  {
    imgSrc: blogImg1,
    date: 'April 2, 2024',
    by: 'By ABHISHEK BHARAJ',
    heading: 'Understanding Insurance: Your Shield for Life’s Uncertainties',
    content: 'In today’s rapidly changing world, insurance stands',
    webLink: link1,
  },
  {
    imgSrc: blogImg2,
    date: 'March 14, 2024',
    by: 'By Stashfin',
    heading: 'Exploring Cyber Insurance: Importance and Coverage',
    content:
      'The evolution of financial technology or fintech, such as the digitalization of banking and insurance processe',
    webLink: link2,
  },
  {
    imgSrc: blogImg3,
    date: 'April 10, 2024',
    by: 'By ABHISHEK BHARAJ',
    heading: 'Home Insurance – Features and Advantages',
    content:
      'Home insurance is an insurance policy that covers the costs and damage to your home or any insured property.',
    webLink: link3,
  },
];

export const innerOptionsIcons = [
  { name: 'Wallet', icon: img1 },
  { name: 'Loan+Wallet', icon: LoanWallet },
  { name: 'Loan Lite', icon: LoanLite },
  { name: 'Loan Protection', icon: LoanProtection },
  { name: 'Loan Ultra', icon: LoanUltra },
  { name: 'Wellness Lite', icon: Wellnesslite },
  { name: 'Wellness', icon: img4 },
  { name: 'Bike', icon: bike },
  { name: 'Car', icon: Car },
  { name: 'OTT + Loan Protect', icon: OTTLoanProtect },
  { name: 'OTT + Insurance', icon: img5 },
];

export const banners = [
  { image_url: bannerImg, name: 'img1' },
  { image_url: bannerImg, name: 'img1' },
  { image_url: bannerImg, name: 'img1' },
];

export const getIconByName = (name) => {
  const matched = innerOptionsIcons.find((op) => op.name === name);
  return matched ? matched.icon : null;
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export const handleReadMore = (idx) => {
  window.open(blogs[idx].webLink, '_blank');
};

export const getAuthToken = () => {
  let authToken = window.localStorage.getItem('authToken');
  let deviceId = window.localStorage.getItem('deviceId');
  const queryParams = new URLSearchParams(window.location.search);
  if (!authToken) authToken = queryParams.get('auth_token');
  if (!deviceId) deviceId = queryParams.get('device_id');
  return { authToken, deviceId };
};
